<template>
    <div class="form-group margin-bottom-none homepage-variants">
        <div class="label">{{ $t__('Homepage variants') }}</div>
        <span class="help">{{ $t__('what information will be displayed on the homepage') }}</span>
        <div>
            <input type="hidden" :name="`homepage_variant[${theme.slug}]`" :value="active.slug">
            <div class="select-image" @click="showModal">
                <div class="image square width-64">
                    <img :src="active.thumbnail_url" :alt="active.name" class="thumbnail">
                </div>

                <div class="name">
                    {{ active.name }}
                </div>
            </div>
        </div>

        <modal ref="homepageVariantsModal" modal-width="1800px" @after-close="resetSelected">
            <template slot="header">{{ $t__('Homepage variants') }}</template>

            <template slot="body">
                <div class="preview">
                    <div class="browser">
                        <div class="nav">
                            <div class="dots"></div>
                        </div>
                        <div class="body">
                            <div class="body-wrap">
                                <img :src="selected.thumbnail_url" :alt="selected.name">
                            </div>
                        </div>
                    </div>
                </div>

                <div class="list">
                    <div class="list-wrap">
                        <div class="item">
                            <label class="radio-block">
                                <input
                                    type="radio"
                                    name="homepage_variant"
                                    :value="defaultHomepageVariant.slug"
                                    :checked="selected.slug == defaultHomepageVariant.slug"
                                    @click="select(defaultHomepageVariant)"
                                >
                                <div>
                                    <div class="homepage-variant">
                                        <div class="thumb" :style="{backgroundImage: `url('${defaultHomepageVariant.thumbnail_url}')`}"></div>
                                        <div class="name">{{ defaultHomepageVariant.name }}</div>
                                    </div>
                                </div>
                            </label>
                        </div>

                        <div class="item" v-for="(homepageVariant, index) in homepageVariants" :key="index">
                            <label class="radio-block">
                                <input
                                    type="radio"
                                    name="homepage_variant"
                                    :value="homepageVariant.slug"
                                    :checked="selected.slug == homepageVariant.slug"
                                    @click="select(homepageVariant)"
                                >
                                <div>
                                    <div class="homepage-variant">
                                        <div class="thumb" :style="{backgroundImage: `url('${homepageVariant.thumbnail_url}')`}"></div>
                                        <div class="name">{{ homepageVariant.name }}</div>
                                    </div>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>
            </template>

            <template slot="footer">
                <button class="btn medium-sm positive narrow float-right" type="button" @click="setActive">{{ $t__('Ok') }}</button>
            </template>
        </modal>
    </div>
</template>

<script>
    export default {

        name: "HomepageVariants",

        props: ['theme', 'default-homepage-variant', 'active-homepage-variant', 'homepage-variants'],

        data() {
            return {
                active: null,
                selected: null,
                modal: {}
            }
        },

        created() {
            this.active = this.activeHomepageVariant;
            this.selected = this.active;
        },

        mounted() {
            this.modal = this.$refs.homepageVariantsModal;
        },

        watch: {
            selected(selected) {
                this.selected = selected;
            },

            active(active) {
                this.active = active;
            }
        },


        methods: {
            select(option) {
                this.selected = option;
            },

            resetSelected() {
                this.selected = this.active;
            },

            setActive() {
                this.active = this.selected;
                this.modal.show = false;
            },

            showModal() {
                this.modal.show = true;
            }
        }
    };
</script>
